module.exports = __webpack_public_path__ + "static/tunisie-a3224f46f3430b2ba0cd4363268d1f81.jpg";